import { useMutation } from '@tanstack/react-query';
import { useFetch } from '@/hooks/useFetch';
import type { ErrorResponse } from '@/types/apiTypes';
import type { CreateRelatedPassengerResponse } from '@/types/clientsApiTypes';
import { RELATIONSHIP_TYPES } from '@/types/clientsApiTypes';

export const useCreateRelatedPassenger = () => {
  const { doFetch: createRelatedPassenger } = useFetch<unknown, CreateRelatedPassengerResponse>();

  return useMutation<CreateRelatedPassengerResponse, ErrorResponse<unknown>, number>({
    mutationFn: (primaryPassengerId: number) =>
      createRelatedPassenger(`/api/clients/${primaryPassengerId}/related-passenger/touch`, {
        method: 'POST',
        body: {
          relationship: RELATIONSHIP_TYPES.sibling,
        },
      }),
  });
};
